class IterableIterator {
  [Symbol.iterator]() {
    return this;
  }

}

exports.IterableIterator = IterableIterator;